import { Card } from '../Card'
import Styles from './ReviewRequestCard.module.scss'
import {
  InformalFeedbackRequest,
  InformalFeedbackReviewDismissReason,
} from 'api/clients/InformalFeedbackRequestsClient'
import dayjs from 'dayjs'
import { Header } from './Header'
import { displayDateFrom } from 'utils/dates'
import { ReviewersList } from './ReviewersList'
import { Content } from './Content'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { ViewSummaryButton } from './Buttons/ViewSummaryButton'
import { EndReviewButton } from './Buttons/EndReviewButton'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  request: InformalFeedbackRequest
  isPostableOrDesign: boolean
}

export const RequesterCard = ({ request, isPostableOrDesign }: Props) => {
  const { isMobile } = useResponsiveDesign()
  if (!request) return null

  const creationDate = dayjs(request.created_at).format('MMM D, YYYY')
  const reviews = request.reviews.filter(
    (review) => review.dismissed_reason !== InformalFeedbackReviewDismissReason.RemovedFromReview,
  )

  return (
    <Card
      className={cx(Styles.reviewRequestCard, {
        [Styles.isPostableOrDesign]: isPostableOrDesign,
        [Styles.isDesign]: !!request.design,
      })}
    >
      <Header status={`Due ${displayDateFrom(request.ends_on)}`} />
      <Content request={request}>
        <div className={cx(Styles.titleContainer, Styles.requester)}>
          <Text variant="largeList" color="var(--dark-80)">
            You asked {reviews.length} {reviews.length > 1 ? 'people' : 'person'} to review this file
          </Text>
          {(!isPostableOrDesign || !isMobile) && <span className={Styles.creationDate}>{creationDate}</span>}
        </div>
        <ResponsiveDesign.Desktop>
          <ReviewersList request={request} />
        </ResponsiveDesign.Desktop>
      </Content>
      <div className={Styles.footer}>
        <EndReviewButton request={request} variant="tertiary" fullWidth />
        <ViewSummaryButton request={request} variant="tertiary" fullWidth />
      </div>
    </Card>
  )
}
